class OnSiteRegistrationConfirmationEmailSettings {
    constructor(data) {
        this.subject = data.subject || '';
        this.bodyText = data.bodyText || '';
    }
}

export default OnSiteRegistrationConfirmationEmailSettings;
